import { render, staticRenderFns } from "./ClassDisplayItem.vue?vue&type=template&id=4b7eabfb&scoped=true"
import script from "./ClassDisplayItem.vue?vue&type=script&lang=js"
export * from "./ClassDisplayItem.vue?vue&type=script&lang=js"
import style0 from "./ClassDisplayItem.vue?vue&type=style&index=0&id=4b7eabfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7eabfb",
  null
  
)

export default component.exports